import * as types from './types';
import { loading } from 'State/actions';

export const getInitialData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PROCESSED_DOCUMENTS_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('processeddocuments');
      dispatch({
        type: types.GET_PROCESSED_DOCUMENTS,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.PROCESSED_DOCUMENTS_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.PROCESSED_DOCUMENTS_FETCHING, false));
  };
};

export const getProcessedDocumentData = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PROCESSED_DOCUMENTS_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `processeddocuments/${id}/data`
      );
      dispatch({
        type: types.PROCESSED_DOCUMENTS_GET_DATA,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.PROCESSED_DOCUMENTS_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.PROCESSED_DOCUMENTS_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/processeddocuments/state/page/actions.js